import { TableConfig } from '@shared/interfaces/table/table-config';
import { datahubPartial } from '@shared/partials/datahub.partial';
import { validFromPartialTable } from '@shared/partials/validfrom-partial.table';
import { validToPartialTable } from '@shared/partials/validto-partial.table';
import { meteringPointTypePartial } from '@shared/partials/meteringpointtype-partial.table';
import { settlementmethodPartial } from '@shared/partials/settlementmethod.partial';
import { physicalStatusPartial } from '@shared/partials/physicalstatus.partial';
import { isChildPartial } from '@shared/partials/isChildPartial';
import { meteringPointSubtypePartial } from '@shared/partials/meteringpointsubtype.partial';
import { meterReadingOccurrencePartial } from '@shared/columns/meteringpoint.columns';
import { DATE_TIME_FORMAT } from '@app/core/constants/date-time-format';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';
import { htxPartialTable } from '@shared/partials/htx-partial.table';
import { MeteringPointHistoricalDto } from '@app/api/dmc';


export const meteringPointHistoryTable: TableConfig<MeteringPointHistoricalDto> = {
  selectable: true,
  selectableType: 'multiple',
  columns: [
    {
      title: 'common.table.index',
      key: 'index'
    },
    {
      title: 'common.table.created',
      key: 'created',
      cellRenderer: DateCellComponent,
      cellRendererParams: {
        format: DATE_TIME_FORMAT,
      }
    },
    validFromPartialTable,
    validToPartialTable,
    meteringPointTypePartial,
    meteringPointSubtypePartial,
    meterReadingOccurrencePartial,
    settlementmethodPartial,
    physicalStatusPartial,
    datahubPartial,
    htxPartialTable,
    isChildPartial
  ]
}
